import { css } from 'aphrodite';
import * as React from 'react';
import { Pill } from '../../../web/components-v2/Pill';
import { formatFreshness } from './repCardFreshness';
import { styleSheet } from './repCards.styles';

/** Coarse enough that a grid of cards costs nothing, fine enough that a minute boundary lands late by seconds. */
const TICK_MS = 15_000;

interface IProps {
	updatedAt: number | null;
}

/** How old a card's calls are, so a quiet card reads as "nothing new" instead of "nothing loading". */
export function FreshnessBadge({ updatedAt }: IProps) {
	const [now, setNow] = React.useState(() => Date.now());

	React.useEffect(() => {
		const timer = window.setInterval(() => setNow(Date.now()), TICK_MS);
		return () => window.clearInterval(timer);
	}, []);

	const { label, tone, title } = formatFreshness(updatedAt ? now - updatedAt : null);

	return (
		<span className={css(styleSheet.freshness)} title={title} aria-label={title}>
			<Pill variant='tag' size='small' color={tone} label={label} />
		</span>
	);
}
